module.exports = __webpack_public_path__ + "static/media/banner.033a4faf.png";